<ul
  app-submenu
  [item]="sidenavItems"
  [root]="true"
  class="ultima-menu ultima-main-menu clearfix"
  [reset]="reset"
  [visible]="true"
></ul>
